import { FunctionComponent, useEffect, useState } from 'react'
import { useTranslation } from 'react-i18next'
import styles from './supportDialog.module.scss'
import Dialog from '@/components/_custom/Dialog/Dialog'
import DialogHeader from '@/components/_custom/DialogHeader/DialogHeader'
import DialogBody from '@/components/_custom/DialogBody/DialogBody'
import ButtonTextIcon from '@/components/_custom/Buttons/ButtonTextIcon/ButtonTextIcon'
import CachedIcon from '@mui/icons-material/Cached'
import HelpIcon from '@mui/icons-material/Help'
import { removeServiceWorker } from '@/modules/utils/serviceWorker'
import { useMutation } from '@apollo/client'
import { Device, DeviceInfo } from '@capacitor/device'
import { SEND_HELP_SUPPORT } from '@/modules/API/account/accountHandler'
import { useNotification } from '@/modules/context/NotificationContext.tsx'

interface resetPasswordDialogProps {
    open: boolean
    handleClose: () => void
    isParent?: boolean
    email: string
}

const SupportDialog: FunctionComponent<resetPasswordDialogProps> = ({
    open,
    handleClose,
    isParent = false,
    email
}: resetPasswordDialogProps) => {
    const { t } = useTranslation()

    const { showNotificationSuccess, showNotificationError } = useNotification()

    const [deviceInfo, setDeviceInfo] = useState<DeviceInfo>()

    const [sendHelp] = useMutation(SEND_HELP_SUPPORT, {
        variables: {
            email: email,
            deviceInfo: deviceInfo
        },
        onCompleted: (): void => {
            handleClose()

            showNotificationSuccess(t('helpSent'))
        },
        onError: (): void => {
            handleClose()

            showNotificationError(t('helpNotSent'))
        }
    })

    useEffect(() => {
        async function getInfo(): Promise<void> {
            setDeviceInfo(await Device.getInfo())
        }

        getInfo()
    }, [])

    return (
        <Dialog open={open} handleClose={handleClose}>
            <DialogHeader title={t('support')} parent={isParent} />
            <DialogBody>
                <div className={styles.DialogBody}>
                    <div className={styles.ButtonContainer}>
                        <ButtonTextIcon
                            type={'close'}
                            onClick={handleClose}
                            parent={isParent}
                            className={styles.Button}
                            fullWidth
                        />
                        <ButtonTextIcon
                            type={'custom'}
                            customText={t('refresh')}
                            customIcon={<CachedIcon />}
                            onClick={removeServiceWorker}
                            parent={isParent}
                            className={styles.Button}
                            fullWidth
                        />
                        <ButtonTextIcon
                            type={'custom'}
                            customText={t('help')}
                            customIcon={<HelpIcon />}
                            onClick={sendHelp}
                            parent={isParent}
                            className={styles.Button}
                            fullWidth
                        />
                    </div>
                </div>
            </DialogBody>
        </Dialog>
    )
}

export default SupportDialog
